// --- ANIMATE ---
$('[data-animate=fadeInUp]').addClass('animate-hidden').viewportChecker({
	classToAdd: 'animate-visible animated fadeInUp',
	offset: 50,
	repeat: true,
});


// --- FANCYBOX ---
var image = 'a[href$=".gif"],a[href$=".jpg"],a[href$=".jpeg"],a[href$=".png"],a[href$=".svg"],a[href$=".GIF"],a[href$=".JPG"],a[href$=".JPEG"],a[href$=".PNG"],a[href$=".SVG"]';
$(image,':not([data-fancybox])').attr('data-fancybox','');
$('.gallery').each(function(){
	id = $(this).attr('id');
	$(image,this).attr('data-fancybox',id);
});
$('[data-fancybox]').fancybox({
	buttons : [
		'close'
	],
});

// --- GTAG EVENTS TRACKING - RESOURCES ---
if ( $('body').hasClass('page-template-resources-page') && typeof gtag == 'function' ) {
	$('a.btn.resource-item-button').each(function () {
		$(this).on('click', function () {
			gtag('event', 'resources_button_click', {
				'event_category' : $(this).attr('data-event-category'),
				'event_label' : $(this).attr('data-event-title'),
			});
		})
	});
}
